import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {createNamespace} from '../../common/utils';
import {getComponentName} from '../../common/utils/namespace';
import {addUnit} from '../../common/utils/format';
import MaiIcon from '../icon';
import {ChildrenMixin} from '../../common/utils/relation';

var _createNamespace = createNamespace('checkbox'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

var IconWrapper = {
    functional: true,
    render: function render(h, config) {
        var $slots = config.slots().default;
        var _config$props = config.props,
            classes = _config$props.classes,
            iconStyle = _config$props.iconStyle,
            iconSize = _config$props.iconSize;
        var style = {};

        if (iconSize) {
            style['fontSize'] = addUnit(iconSize);
        }

        if ($slots) {
            return h(
                'div',
                {
                    class: b('slot'),
                    style: style
                },
                [$slots]
            );
        }

        return h(
            'div',
            {
                class: classes,
                style: style
            },
            [
                h('mai-icon', {
                    attrs: {
                        name: 'success'
                    },
                    style: iconStyle
                })
            ]
        );
    }
};
var LabelWrapper = {
    functional: true,
    render: function render(h, config) {
        var $slots = config.slots().default;
        var classes = config.props.classes;
        return $slots
            ? h(
                  'span',
                  {
                      class: classes,
                      ref: 'label'
                  },
                  [$slots]
              )
            : '';
    }
};
export default {
    mixins: [ChildrenMixin('Checkbox')],
    name: getComponentName('Checkbox'),
    data: function data() {
        return {};
    },
    props: {
        name: null,
        value: null,
        disabled: Boolean,
        checkedColor: String,
        size: [Number, String],
        iconSize: [Number, String],
        labelDisabled: Boolean,
        labelClass: null,
        shape: {
            type: String,
            default: 'round'
        }
    },
    computed: {
        checked: {
            get: function get() {
                var _a, _b;

                return this.parent
                    ? ((_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0
                          ? void 0
                          : _b.indexOf(this.name)) !== -1
                    : this.value;
            },
            set: function set(val) {
                if (this.parent) {
                    this.setParentValue(val);
                } else {
                    this.$emit('input', val);
                }
            }
        },
        isDisabled: function isDisabled() {
            return this.disabled;
        },
        iconStyle: function iconStyle() {
            var checkedColor = this.checkedColor,
                checked = this.checked,
                isDisabled = this.isDisabled;

            if (checkedColor && checked && !isDisabled) {
                return {
                    borderColor: checkedColor,
                    backgroundColor: checkedColor
                };
            }
        }
    },
    watch: {
        value: function value(val) {
            this.$emit('change', val);
        }
    },
    methods: {
        setParentValue: function setParentValue(val) {
            var parent = this.parent;
            var value = parent.value.slice();

            if (val) {
                if (parent.max && value.length >= parent.max) {
                    return;
                }

                if (value.indexOf(this.name) === -1) {
                    value.push(this.name);
                    parent.$emit('input', value);
                }
            } else {
                var index = value.indexOf(this.name);

                if (index !== -1) {
                    value.splice(index, 1);
                    parent.$emit('input', value);
                }
            }
        },
        onClick: function onClick(event) {
            var label = this.$refs.label;
            var target = event.target;
            var labelClicked = label && (label === target || label.contains(target));

            if (!this.isDisabled && !(labelClicked && this.labelDisabled)) {
                this.toggle();
            }

            this.$emit('click', event);
        },
        toggle: function toggle(checked) {
            var _this = this;

            if (checked === void 0) {
                checked = !this.checked;
            }

            clearTimeout(this.toggleTask);
            this.toggleTask = setTimeout(function() {
                _this.checked = checked;
            });
        },
        getAttrs: function getAttrs() {
            var checked = this.checked;
            var attrs = {
                'aria-checked': String(checked)
            };
            return attrs;
        }
    },
    render: function render() {
        var h = arguments[0];
        var shape = this.shape,
            checked = this.checked,
            isDisabled = this.isDisabled,
            size = this.size,
            iconStyle = this.iconStyle,
            iconSize = this.iconSize,
            labelClass = this.labelClass;
        var getAttrs = this.getAttrs,
            onClick = this.onClick;
        var style = {};

        if (size) {
            style['fontSize'] = addUnit(size);
        }

        return h(
            'div',
            _mergeJSXProps([
                {},
                {
                    attrs: getAttrs()
                },
                {
                    class: b(),
                    on: {
                        click: onClick
                    },
                    style: style
                }
            ]),
            [
                h(
                    IconWrapper,
                    {
                        attrs: {
                            classes: b('icon', [
                                shape,
                                {
                                    disabled: isDisabled,
                                    checked: checked
                                }
                            ]),
                            iconSize: iconSize,
                            iconStyle: iconStyle
                        }
                    },
                    [
                        this.$scopedSlots.icon &&
                            this.$scopedSlots.icon({
                                checked: checked
                            })
                    ]
                ),
                h(
                    LabelWrapper,
                    {
                        attrs: {
                            classes: [
                                b('label', [
                                    {
                                        disabled: isDisabled
                                    }
                                ]),
                                labelClass
                            ]
                        }
                    },
                    [this.$slots.default]
                )
            ]
        );
    },
    components: {
        MaiIcon: MaiIcon
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
